import { SalesTypes, EntityTypes } from 'context/entityContext';

export type TAllowedEntityTypes = Exclude<EntityTypes, 'album'>;

type TAllowedCustomerFilters = Record<TAllowedEntityTypes, any>;

const allowedCustomerFilters: TAllowedCustomerFilters = {
  track: {
    equivalents: ['streaming', 'download'],
    streaming: ['streaming'],
    downloads: ['download'],
    track_downloads: ['download'],
    physical: [],
    positions: ['charts'],
  },
  artist: {
    equivalents: ['streaming', 'download'],
    streaming: ['streaming'],
    downloads: ['download'],
    track_downloads: ['download'],
    album_downloads: ['download'],
    physical: [],
    positions: ['charts'],
  },
  label: {
    equivalents: ['streaming'],
    streaming: ['streaming'],
    downloads: [],
    physical: [],
    positions: ['charts'],
  },
  release: {
    equivalents: ['streaming', 'download'],
    streaming: ['streaming'],
    downloads: ['download'],
    album_downloads: ['download'],
    physical: [],
    positions: ['charts'],
  },
  project: {
    equivalents: ['streaming', 'download'],
    streaming: ['streaming'],
    downloads: ['download'],
    track_downloads: ['download'],
    album_downloads: ['download'],
    physical: [],
    positions: ['charts'],
  },
};

export default function getAllowedCustomerFilters(
  salesType: SalesTypes,
  entityType: TAllowedEntityTypes
): any {
  if (salesType && entityType) {
    return allowedCustomerFilters[entityType]?.[salesType] ?? [];
  }

  return [];
}
